// extracted by mini-css-extract-plugin
export default {"k":"l2_k__OfnKy","active":"l2_active__HwKT0"};